module.exports = __webpack_public_path__ + "img/euro.e2472fec.svg";